<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  getRoleMapping,
  add,
  del,
  update,
  getDetails
} from "@/api/user/role_map";

import cTable from "@/base/common/index";
export default {
  name: "role_map",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getRoleMapping,
        getDetails,
        del,
        add,
        update
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              console.log(row);
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            title: this.$t("handle"),
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "name cannot be empty",
                  trigger: "blur"
                }
              ],
              code: [
                {
                  required: true,
                  message: "code cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ name: 24 }, { code: 24 }],
          fields: [
            {
              name: () => this.$t("roleName"),
              key: "name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("roleName");
              }
            },
            {
              name: () => this.$t("type"),
              key: "code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("type");
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 439
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },

        {
          name: () => this.$t("roleName"),
          key: "name",
          align: "left",
          minWidth: 100,
          tooltip: true
        },
        {
          name: () => this.$t("type"),
          key: "code",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("createTime"),
          align: "center",
          key: "create_time",
          minWidth: 160
        },
        {
          name: () => this.$t("upTime"),
          align: "center",
          key: "update_time",
          minWidth: 160
        },
        {
          type: "btns",
          width: 120,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 440
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 441
            }
          ],

          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "country_id")
        item.options = (await getCountry()).data.payload.rows;
    });
  }
};
</script>
